import jsPDF from "jspdf";
import "jspdf-autotable";
import Logo1 from "../../assets/landing_page/Icons/planshare-icon.png";

export const handleDownloadPDF = (
  planName,
  customerName,
  planDescription,
  passlength,
  passedData,
  failLength,
  failedData
) => {
  const doc = new jsPDF();

  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("Healthcare", 14, 15);

  // Add PlanShare logo
  doc.addImage(Logo1, "PNG", 160, 5, 10, 10);
  doc.setFontSize(14);
  doc.text("PlanShare", 170, 15);

  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.line(10, 20, 200, 20);

  doc.setFontSize(12);
  doc.text("Plan Details", 14, 25);

  // Plan Details
  doc.setFontSize(10);
  doc.text(`Plan Name: ${planName}`, 14, 34);
  doc.text(`Customer Name: ${customerName}`, 14, 40);
  doc.text(`Plan Description: ${planDescription}`, 14, 46);

  // Passed Table
  doc.setFillColor(214, 244, 222);
  doc.rect(14, 55, 182, 8, "F");
  doc.setTextColor(0, 128, 0);
  doc.setFontSize(12);
  doc.text(`Passed (${passlength})`, 16, 61);

  // Define headers without icons
  const headers = [
    ["S.No","Metric", "Task ID", "Task Name", "Duration", "Start Date", "End Date", /* "Resource", */ "Report Description"],
  ];

  doc.autoTable({
    startY: 65,
    head: headers,
    body: passedData.map((row ,index) => [
      index + 1,
      row.ruleName || "",
      row.taskId || "",
      row.taskName || "",
      row.duration || "",
      row.startDate || "",
      row.endDate || "",
     // row.resource || "",
      row.description || "",
    ]),
    styles: { fontSize: 8 },
    theme: "grid",
    headStyles: { minCellHeight: 14, cellWidth: 'wrap', halign: 'center' },
  });

  // Add a new page for Failed Table
  doc.addPage();

  // Failed Table
  doc.setFillColor(255, 212, 204);
  doc.rect(14, 20, 182, 8, "F");
  doc.setTextColor(255, 40, 0);
  doc.text(`Failed (${failLength})`, 16, 26);

  doc.autoTable({
    startY: 30,
    head: headers,
    body: failedData.map((row,index) => [
      index + 1,
      row.ruleName || "",
      row.taskId || "",
      row.taskName || "",
      row.duration || "",
      row.startDate || "",
      row.endDate || "",
     // row.resource || "",
      row.description || "",
    ]),
    styles: { fontSize: 8 },
    theme: "grid",
    headStyles: { minCellHeight: 14, cellWidth: 'wrap', halign: 'center' },
  });

  // Footer
  doc.setFontSize(10);
  doc.text("© 2025 PlanShare.ai – All Rights Reserved.", 14, doc.internal.pageSize.height - 10);

  // Save PDF
  doc.save("Health_Report.pdf");
};

export default handleDownloadPDF;
